export enum ClipspecConnectionErrorCode {
  Unknown = 'ib-clipspec-e0',
  InvalidConfiguration = 'ib-clipspec-e1',
  InvalidOrigin = 'ib-clipspec-e2',
  InvalidWorkflow = 'ib-clipspec-e3',
  MessageSendingFailed = 'ib-clipspec-e4',
}